import { DropdownOptionModel } from './dropdown-option-model';

// TODO: should the values come from enums defined by the Api? The generated code didn't seem to define them
export const MILITARY_BRANCH_OPTIONS: DropdownOptionModel<string>[] = [
  { value: 'Army', display: 'Army' },
  { value: 'Navy', display: 'Navy' },
  { value: 'Airforce', display: 'Airforce' },
  { value: 'Marines', display: 'Marines' },
  { value: 'Coast Guard', display: 'Coast Guard' },
  { value: 'National guard', display: 'National guard' }
];
